<aur-mat-table
  [tableData]="tableData"
  [tableConfig]="tableConfig">

  <button color="primary" mat-button ngxAurTableSearchPrefix> Prefix Button</button>
  <button color="primary" mat-button ngxAurTableSearchSuffix> Suffix Button</button>

</aur-mat-table>
